<ng-container *ngIf="form.get(fieldName) || fieldControl as f">
  <label *ngIf="fieldLabel" [for]="fieldName" class="form-label">{{ fieldLabel }}</label>

  <input
    *ngIf="!readonlyField; else readonlyInput"
    type="date"
    class="form-control"
    [class.is-invalid]="f.errors"
    [class.is-warned-date]="!!warnings"
    [formControl]="f | toFormControl"
    [id]="fieldName"
    [min]="minDate"
    [max]="maxDate"
    [attr.placeholder]="placeholder ? placeholder : null"
  />

  <ng-template #readonlyInput>
    <input
      type="date"
      class="form-control"
      [class.is-invalid]="f.errors"
      [class.is-warned-date]="!!warnings"
      [formControl]="f | toFormControl"
      [id]="fieldName"
      [min]="minDate"
      [max]="maxDate"
      [attr.placeholder]="placeholder ? placeholder : null"
      [attr.disabled]="true"
    />
  </ng-template>

  <div *ngIf="fieldDescription" class="form-text">{{ fieldDescription }}</div>

  <field-warnings [warnings]="warnings"></field-warnings>
  <div field-errors [control]="f"></div>
</ng-container>
